export default function withLayout(component, routesArrays, extra = {}) {
    return {
        path: '/app/projects/:projectUuid',
        component,
        meta: { breadcrumb: () => [], isLayout: true },
        children: routesArrays.flat(),
        ...extra,
    };
}
